import React from 'react'
import { Button, Row, Col } from 'antd'
import { ArrowLeftOutlined, ReloadOutlined } from '@ant-design/icons'
import { Link, useRouteError } from 'react-router-dom'
import { Space } from 'antd'
import i18n from 'lang'

const RootError = () => {
  const error = useRouteError()

  const errors = {
    404: {
      title: i18n.t('errors.not.found.title'),
      desc: i18n.t('errors.not.found.desc'),
    },
    default: {
      title: i18n.t('errors.default.title'),
      desc: i18n.t('errors.default.desc'),
    },
  }

  return (
    <>
      <div className='container-fluid d-flex flex-column justify-content-between h-100 px-md-4 pb-md-4 pt-md-1'>
        <div className='container h-100 d-flex justify-content-between'>
          <Row align='middle'>
            <Col xs={24} sm={24} md={error?.status !== 404 ? 24 : 8}>
              <h1 className='font-weight-bold mb-4 display-6'>
                {errors[error?.status]?.title || errors['default']?.title}
              </h1>

              <p className='font-size-md mb-4'>
                {errors[error?.status]?.desc || errors['default']?.desc}
              </p>

              <Space>
                <Link to='..' relative='path'>
                  <Button type='primary' icon={<ArrowLeftOutlined />}>
                    Voltar
                  </Button>
                </Link>

                {error?.status !== 404 ? (
                  <Link to='.' relative='path'>
                    <Button type='primary' icon={<ReloadOutlined />}>
                      Tentar novamente
                    </Button>
                  </Link>
                ) : null}
              </Space>
            </Col>

            {error?.status === 404 ? (
              <Col xs={24} sm={24} md={{ span: 14, offset: 2 }}>
                <img
                  className='img-fluid mt-md-0 mt-4'
                  src='/img/others/img-20.png'
                  alt=''
                />
              </Col>
            ) : null}
          </Row>
        </div>
      </div>
    </>
  )
}

export default RootError
